<script setup lang="ts">
import HeroSection from '../components/home/HeroSection.vue'
import AboutSection from '../components/home/AboutSection.vue'
import SkillsSection from '../components/home/SkillsSection.vue'
import ProjectsSection from '../components/home/ProjectsSection.vue'
import ContactSection from '../components/home/ContactSection.vue'
</script>

<template>
  <HeroSection />
  <SkillsSection />
  <ProjectsSection />
  <AboutSection />
  <ContactSection />
</template>
